<template>
  <div class="page-body">
    <b-card class="content-card">
      <div>
        <div class="appbar-container">
          <h3 class="appbar-container__title text-right">
            اختصاص جایزه به کاربران
          </h3>
        </div>

        <b-row>
          <b-col :cols="6">

            <b-row>
              <b-col :cols="12">
                <label
                  for=""
                  class="text-right w-100"
                >
                  انتخاب جایزه
                </label>
                <b-select v-model="form.reward_id">
                  <b-select-option
                    v-for="(item,index) in rewards"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </b-select-option>
                </b-select>
              </b-col>

              <b-col
                :cols="12"
                class="my-4"
              >
                <label
                  for=""
                  class="text-right w-100"
                >
                  انتخاب کاربران
                </label>
                <div class="d-flex align-center justify-between">
                  <b-form-input
                    @keyup.enter="searchUser"
                    v-model="searchValue"
                    placeholder="جستجو کاربران بر اساس  شماره موبایل"
                  />
                  <base-button
                    :loading="searchLoading"
                    @click="searchUser"
                    class="mr-2"
                    variant="primary"
                  >

                    <span v-if="!searchLoading">
                      جستجو
                    </span>
                  </base-button>
                </div>

                <div
                  v-if="searchResults.length"
                  class="search-list-container"
                >
                  <div
                    v-for="(item,index) in searchResults"
                    :key="index"
                    @click="addUser(item)"
                    class="search-list-container-item"
                  >
                    {{item.name}} ( {{ item.phoneNumber }} )
                  </div>
                </div>

                <div class="mt-4 text-right">
                  <base-button
                    :loading="importLoading"
                    :disabled="importLoading"
                    variant="primary"
                    class="relative"
                  >
                    <input
                      @change="readCSVFile($event.target)"
                      accept=".csv"
                      style="position: absolute;opacity: 0;width: 100%;height:100%;z-index: 9;cursor: pointer;;"
                      type="file"
                    >
                    <template v-if="!importLoading">
                      <b-icon-download />
                      <span>
                        وارد کردن کاربران
                      </span>
                    </template>
                    <template v-if="importLoading">
                      <span>
                        لطفا صبر کنید
                      </span>
                    </template>
                  </base-button>
                </div>
              </b-col>

              <b-col
                :cols="12"
                class="my-4"
              >
                <base-button
                  :loading="form.loading"
                  @click="submit"
                  style="background-color: green;"
                >
                  ثبت
                </base-button>
              </b-col>
            </b-row>

          </b-col>

          <b-col
            :cols="6"
            class="my-4"
          >
            <h4 class="text-center">
              کاربران انتخاب شده :
            </h4>

            <ul class="user-list">
              <li
                class="user-list-item"
                v-for="(user,index) in form.users"
                :key="index"
              >
                <span v-if="user.name && user.phoneNumber">
                  {{ user.name }} ( {{ user.phoneNumber }} )
                </span>

                <span v-else>
                  {{ user.id }}
                </span>

                <div>
                  <b-icon-trash
                    @click="removeUser(index)"
                    class="user-list-item-icon"
                    style="color:red"
                  />
                </div>
              </li>
            </ul>
          </b-col>

        </b-row>

      </div>
    </b-card>
  </div>

</template>

<script>
import http from "@/httpservices/HttpService";

export default {
  name: "AddToUser",
  data() {
    return {
      rewards: [],
      searchResults: [],
      searchValue: "",
      searchLoading: false,
      importLoading: false,
      form: {
        reward_id: "",
        users: [],
        loading: false,
      },
    };
  },
  methods: {
    addUser(user) {
      const duplicateUser = Boolean(
        this.form.users.find((item) => item.id === user.id) || false
      );
      if (!duplicateUser) {
        this.form.users.push({
          id: user.id,
          name: user.name,
          phoneNumber: user.phoneNumber,
        });
        this.searchResults = [];
      }
    },
    async searchUser() {
      try {
        this.searchLoading = true;
        const { data } = await http.get("Accounts/qt/99999/page/0", {
          params: {
            InfoQuery: this.searchValue,
          },
        });

        this.searchResults = data.map((item) => {
          const getName = (user) => {
            if (user.firstName && user.lastName) {
              return user.firstName + " " + user.lastName;
            }
            return "کاربر جدید";
          };
          return {
            id: item.id,
            name: getName(item),
            phoneNumber: item.cellPhone.number || item.secondCellPhone.number,
          };
        });
      } catch (e) {
        console.log(e);
      }
      this.searchLoading = false;
    },

    async fetchRewards() {
      try {
        const { data } = (
          await http.get("rewards/filter?page_size=9999&page_number=0", {
            baseURL: process.env.VUE_APP_REWARD_CENTER_BASE_URL,
          })
        ).data;
        this.rewards = data.map((item) => {
          return {
            value: item.id,
            text: item.name,
          };
        });
      } catch (e) {
        console.log(e);
      }
    },

    readCSVFile(input) {
      const files = input.files;

      if (files.length > 0) {
        this.importLoading = true;
        // Selected file
        var file = files[0];

        // FileReader Object
        var reader = new FileReader();

        // Read file as string
        reader.readAsText(file);

        // Load event
        reader.onload = async (event) => {
          const data = event.target.result.split("\n");
          data.shift();
          const getName = (user) => {
            if (user.firstName && user.lastName) {
              return user.firstName + " " + user.lastName;
            }
            return "کاربر جدید";
          };
          try {
            const usersToAdd = await Promise.all(
              data.map(async (item) => {
                const users = (
                  await http.get("Accounts/qt/99999/page/0", {
                    params: {
                      InfoQuery: item,
                    },
                  })
                ).data;
                const user = users[0];
                return {
                  id: user.id,
                  name: getName(user),
                  phoneNumber: user.cellPhone.number,
                };
              })
            );
            usersToAdd.map((item) => {
              this.addUser(item);
            });
          } catch (e) {
            console.log(e);
          }
          this.importLoading = false;
        };
      } else {
        alert("Please select a file.");
      }
    },

    removeUser(index) {
      const confirm = window.confirm("آیا مطمئن هستید ؟");
      if (!confirm) return;
      this.form.users.splice(index, 1);
    },

    async submit() {
      this.form.loading = true;
      try {
        await http.post(
          `/rewards/achieve/${this.form.reward_id}`,
          {
            user_ids: this.form.users.map((i) => i.id),
          },
          {
            baseURL: process.env.VUE_APP_REWARD_CENTER_BASE_URL,
          }
        );
        alert("با موفقیت ثبت شد");
        this.form = {
          ...this.form,
          reward_id: "",
          users: [],
          loading: false,
        };
      } catch (e) {
        console.log(e);
      }
      this.form.loading = false;
    },
  },

  mounted() {
    this.fetchRewards();
  },
};
</script>

<style>
.user-list{
    list-style-type: none;
    padding: 0;
    margin: 0;
    max-height: 500px;
    overflow: auto;
}

.user-list-item{
    padding: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background-color: #eee;
}

.user-list-item-icon{
    cursor: pointer;
    margin-left: 8px;    
}

.search-list-container{
    max-height: 300px;
    margin: 10px 0;
    overflow: auto;
    border-radius: 5px;
    box-shadow: 0 0 8px 3px #00000030;
}

.search-list-container-item{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:flex-start;
    padding: 8px;
    cursor: pointer;
    background-color: #eee;
    border-bottom: 1px solid #ccc;
}

.search-list-container-item:hover{
  background-color: #ddd;
}
</style>